import { useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

const JobRow = ({ readOnly, job, onSave, onDelete }) => {
  const [f, setF] = useState({ no: job.no, name: job.name, weight: job.weight });
  const set = (k, num) => (e) => setF((p) => ({ ...p, [k]: num ? Number(e.target.value) : e.target.value }));
  return (
    <div data-testid={`job-editor-row-${job.id}`} className="grid grid-cols-[70px_1fr_80px_auto] gap-2 border-b border-[color:var(--border)] py-3 last:border-0">
      <Input disabled={readOnly} data-testid={`job-no-input-${job.id}`} type="number" value={f.no} onChange={set("no", true)} />
      <Input disabled={readOnly} data-testid={`job-name-input-${job.id}`} value={f.name} onChange={set("name")} />
      <Input disabled={readOnly} data-testid={`job-weight-input-${job.id}`} type="number" min={1} max={10} value={f.weight} onChange={set("weight", true)} />
      {!readOnly && <div className="flex gap-1">
        <Button size="icon" variant="ghost" data-testid={`job-save-${job.id}`} onClick={() => onSave(f, job.id)}><Save className="h-4 w-4" /></Button>
        <Button size="icon" variant="ghost" data-testid={`job-delete-${job.id}`} onClick={() => onDelete(job.id)} className="text-red-400"><Trash2 className="h-4 w-4" /></Button>
      </div>}
    </div>
  );
};

export const JobsEditor = ({ readOnly, jobs, onSave, onDelete }) => (
  <div className="panel p-5">
    <div className="mb-2 flex items-center justify-between">
      <h3 className="font-display text-xl font-bold">Jobs & Weights</h3>
      {!readOnly && <Button data-testid="matrix-add-job-button" variant="outline" size="sm"
        onClick={() => onSave({ no: Math.max(0, ...jobs.map((j) => j.no)) + 1, name: "New Inspection", weight: 1 })}><Plus className="mr-1 h-4 w-4" />Add Job</Button>}
    </div>
    <div className="label grid grid-cols-[70px_1fr_80px_auto] gap-2 pb-1"><span>No.</span><span>Name</span><span>Weight</span><span className="w-20" /></div>
    {jobs.map((j) => <JobRow readOnly={readOnly} key={`${j.id}-${j.no}-${j.name}-${j.weight}`} job={j} onSave={onSave} onDelete={onDelete} />)}
  </div>
);
